import { api } from "./axios";

export async function createNews(data) {
    let res = await api.post("new/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function getAllNews() {
    let res = await api.get("new/getAll");
    if (res) return res.data.data;
    else return false;
}
export async function removeNews(newsId) {
    let res = await api.get("new/remove/" + newsId);
    if (res) return res.data.data;
    else return false;
}